import dashboardApi from 'api/dashboardApi'

const dashboardApiSlice = dashboardApi.injectEndpoints({
  endpoints: (build) => ({
    getDashboardCount: build.query<any, { subId?: number } | void>({
      query: ({ subId } = {}) => ({
        url: subId ? `/dashboard/count?subId=${subId}` : '/dashboard/count',
        method: 'GET'
      })
    }),
    getAllComapny: build.query<any, void>({
      query: () => ({
        url: '/company/extended',
        method: 'GET'
      })
    })
  })
})
export const { useGetDashboardCountQuery, useGetAllComapnyQuery } =
  dashboardApiSlice
export default dashboardApiSlice
